import { T2, TEXT_LENGTH, SuperPop } from '@nile/components';
import { Button } from '@superops/ui-design-system';
import { includes } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';

const Input = styled.input`
  height: 30px;
  border: none;
  border-bottom: 1px solid #ececec;
  margin-bottom: 10px;
  background-color: transparent;
  outline: none;
`;

function MultiTextField(props) {
  const {
    placeholder,
    label,
    name,
    deleteButton,
    onItemAdded,
    onItemDeleted,
    className,
    labelClassName,
    charCodes,
    values: inputValues,
    shouldAddOnBlur,
    addHelper,
    handleValidation,
    readOnly,
    fullWidth,
    superPop,
    disabled
  } = props;
  const [values, setValues] = useState(inputValues || []);
  const [value, setValue] = useState('');

  const handleItemAdd = (val) => {
    if (
      includes(values, val) ||
      !val ||
      (handleValidation && !handleValidation(val))
    ) {
      setValue(val);
      return;
    }
    const newValues = values.concat(value);
    setValues(newValues);
    setValue('');
    onItemAdded(value, newValues);
  };

  const handleItemRemove = (value) => {
    const newValues = values.filter((v) => v !== value);
    onItemDeleted(value, newValues);
    setValues(newValues);
  };

  const handleBlur = (e) => {
    // 13: Enter
    if (shouldAddOnBlur) {
      e.preventDefault();
      handleItemAdd(e.target.value);
    }
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  const handleKeypress = (e) => {
    if (includes(charCodes, e.charCode)) {
      e.preventDefault();
      handleItemAdd(e.target.value);
    }
  };

  return (
    <div className="multiple-value-text-input">
      <T2>{label || ''}</T2>
      <div
        className={`items-holder flex wrap mt-10 ${
          fullWidth ? 'mw-100' : 'mw-300'
        }`}
      >
        {values.length > 0
          ? values.map((el) => {
              return (
                <Item>
                  <div>{el}</div>
                  <Delete
                    className="multi-text-delete"
                    tabIndex="-1"
                    role="button"
                    onKeyPress={() => handleItemRemove(el)}
                    onClick={() => handleItemRemove(el)}
                  >
                    {deleteButton}
                  </Delete>
                </Item>
              );
            })
          : ''}
      </div>
      <div className={`${superPop ? 'flex actr g10' : ''}`}>
        <Input
          name={name}
          placeholder={placeholder || 'Type value and press enter'}
          value={value}
          type="text"
          onKeyPress={handleKeypress}
          onChange={handleValueChange}
          onBlur={handleBlur}
          className={className}
          maxLength={TEXT_LENGTH.size_4}
          readOnly={readOnly}
          disabled={disabled}
        />
        {addHelper && (
          <Button
            onClick={() => {
              handleItemAdd(value);
            }}
            plain
          >
            Add
          </Button>
        )}
        {superPop && <SuperPop {...superPop} />}
      </div>
    </div>
  );
}

const Item = styled.div`
  display: flex;
  align-items: center;
  background: #ececec;
  border-radius: 5px;
  padding: 4px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const Delete = styled.div`
  margin-left: 8px;
  cursor: pointer;
  outline: none;
`;

MultiTextField.defaultProps = {
  placeholder: '',
  charCodes: [13],
  deleteButton: <span>&times;</span>,
  values: [],
  label: '',
  shouldAddOnBlur: true,
  className: '',
  labelClassName: ''
};

export default MultiTextField;
